import moment from 'moment';
import { useSearchParams } from 'react-router-dom';

import type { DayNumber } from '@app/components/Calendars/components/DayNumber/types';
import { daysShort } from '@app/pages/TasksList/constants/dates';
import { useTaskListContext } from '@app/providers/TaskListProvider';

import type { Moment } from 'moment';

export const useDailyCalendar = () => {
  const [, setSearchParams] = useSearchParams();
  const {
    currentDate,
    toPrevDate,
    toNextDate,
    dailyTasks,
    isCalendarsTabsLoading,
    createTaskForRange,
    openPreviewTaskModal,
  } = useTaskListContext();

  const getDayNumbers = () => {
    const { year, month, day } = currentDate;
    const currentMoment = moment(`${year}-${month}-${day}`, 'YYYY-M-D');
    const week = currentMoment.isoWeek().toString() || '';
    const weekDays = Array.from({ length: 7 }, (_, i) =>
      moment()
        .year(year)
        .week(+week)
        .isoWeekday(i + 1)
    );
    return weekDays.map((date: Moment) => {
      const year = date.year().toString();
      const month = (date.month() + 1).toString();
      const dayNumber = date.date();
      const day = dayNumber.toString();
      const isToday = date.isSame(moment(), 'day');
      const isSelectedDay = date.isSame(currentMoment, 'day');
      const title = daysShort[date.isoWeekday() as keyof typeof daysShort];
      const onClick = () => setSearchParams({ tab: 'day', year, month, day });

      const clickable = true;
      return { isSelectedDay, dayNumber, isToday, title, onClick, clickable };
    });
  };

  const toPrevDay = toPrevDate;
  const toNextDay = toNextDate;
  const dayNumbers: Array<DayNumber> = getDayNumbers();
  const tasks = [{ ...dailyTasks, id: 'daily' }];

  return {
    toPrevDay,
    toNextDay,
    tasks,
    createTaskForRange,
    openPreviewTaskModal,
    dayNumbers,
    isLoading: isCalendarsTabsLoading,
  };
};
